import type { ReactElement } from 'react'

export type BasketDiscountInfo = {
  amount: string
  discount: string
  difference: string
}

function getFormattedDiscount(basketDiscount: Core.Discount): string {
  if (basketDiscount.absolute && basketDiscount.percent)
    return `${basketDiscount.absolute.formatted} + ${basketDiscount.percent.formatted}`
  if (basketDiscount.absolute && !basketDiscount.percent) return basketDiscount.absolute.formatted
  if (!basketDiscount.absolute && basketDiscount.percent) return basketDiscount.percent.formatted
  // should never happen because data validation is handled by the API
  return ''
}

export function findPotentialBasketDiscount(
  locale: string,
  subAmountValue: number,
  basketDiscounts: Core.Discount[] | null,
): BasketDiscountInfo | null {
  const basketDiscount = basketDiscounts?.find((discount) => discount.minimumAmount.amount > subAmountValue)

  return basketDiscount
    ? {
        amount: basketDiscount.minimumAmount.formatted,
        difference: new Intl.NumberFormat(locale.replace('_', '-'), {
          style: 'currency',
          currency: basketDiscount.minimumAmount.currency,
        }).format(basketDiscount.minimumAmount.amount - subAmountValue),
        discount: getFormattedDiscount(basketDiscount),
      }
    : null
}

type BasketDiscountMessageProps = {
  basketDiscountInfo: BasketDiscountInfo
} & TranslateProps

export default function BasketDiscountMessage({
  basketDiscountInfo,
  t,
}: Readonly<BasketDiscountMessageProps>): ReactElement {
  return (
    <div className="cart-info-message">
      {t('views.storefrontView.basketPageSection.basketDiscountMessage', {
        amount: basketDiscountInfo.amount,
        difference: basketDiscountInfo.difference,
        discount: basketDiscountInfo.discount,
      })}
    </div>
  )
}
